// extracted by mini-css-extract-plugin
export default {"toolsPanel":"_2x9S9oWl9QZegmhlW7QV-e","buttons":"_1b8EZSm10214JvpU0hXMsq","inlineBlock":"_1b8o41TFtDvuJEQG8sEfE1","active":"_3-8LeNKyQMKMzXpJszTKYT"};